import { userApi as api, userSilentApi as silentApi } from "../../utils/apiInstances";

export const handleOrganizerFetchPitches = async () => {
    try {
        const response = await silentApi("GET", "/organizer/pitches");
        return response;
    } catch (error) {
        console.error("Failed to fetch organizer pitches:", error);
        throw error;
    }
};

export const handleOrganizerFetchPitch = async (pitchId: string | number) => {
    try {
        const response = await silentApi("GET", `/organizer/pitches/${pitchId}`);
        return response;
    } catch (error) {
        console.error("Failed to fetch organizer pitch:", error);
        throw error;
    }
};

export const handleOrganizerCreatePitch = async (payload: unknown) => {
    try {
        const response = await api("POST", "/organizer/pitches", payload);
        return response;
    } catch (error) {
        console.error("Failed to create organizer pitch:", error);
        throw error;
    }
};

export const handleOrganizerUpdatePitch = async (pitchId: string | number, payload: unknown) => {
    try {
        const response = await api("PATCH", `/organizer/pitches/${pitchId}`, payload);
        return response;
    } catch (error) {
        console.error("Failed to update organizer pitch:", error);
        throw error;
    }
};

export const handleOrganizerDeletePitch = async (pitchId: string | number) => {
    try {
        const response = await api("DELETE", `/organizer/pitches/${pitchId}`);
        return response;
    } catch (error) {
        console.error("Failed to delete organizer pitch:", error);
        throw error;
    }
};
